import Plugin from 'src/plugin-system/plugin.class';

export default class TypographyPlugin extends Plugin {

    init() {

        var that = this;

        this.headlines = document.querySelectorAll(".hero-h1__wrapper");
        var headlineObserver = new IntersectionObserver (function (entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    that._setLineWidth(entry.target.querySelector('.hero-h1__letters'), entry.target.querySelector('.hero-h1__line'))
                }
            });
        });

        this.headlines.forEach(function(element) {
            headlineObserver.observe(element);
        });

        $("textarea").each(function () {
            this.setAttribute("style", "height:" + (this.scrollHeight) + "px;overflow-y:hidden;");
          }).on("input", function () {
            this.style.height = "auto";
            this.style.height = (this.scrollHeight) + "px";
        });
        
    }

    _setLineWidth(lettersElement, lineElement) {

        const umlautMap = [
            'ä',
            'ü',
            'ö'
        ];

        var letters = lettersElement.textContent.toLowerCase();
        var hasUmlaut = umlautMap.some(v => letters.includes(v));
        var width = lettersElement.offsetWidth - 3;

        if (hasUmlaut) {
            lineElement.classList.add('has--umlaut');
        }
        lineElement.style.width = width + 'px';

        //console.log('hat umlaut:', hasUmlaut)

        //console.log(umlautMap); //lettersElement);
    }

    _registerEvents() {
        document.addEventListener('Viewport/hasChanged', () => {
            this._handleResize();
        });
    }

    _handleResize() {
        this.headlines.forEach((element) => {
            this._setLineWidth(element.querySelector('.hero-h1__letters'), element.querySelector('.hero-h1__line'))
        });
    }

}